export default __webpack_public_path__ + "static/media/home.f1b704b1.svg";